import { createSlice } from '@reduxjs/toolkit';

const dirtySlice = createSlice({
    name: 'dirty',
    initialState: {
        isDirty: false,
        originalValues: null,
    },
    reducers: {
        setDirty: (state) => {
            state.isDirty = true;
        },
        resetDirty: (state) => {
            state.isDirty = false;
            state.originalValues = null;
        },
        setOriginalValues: (state, action) => {
            state.originalValues = action.payload;
            state.isDirty = false;
        },
        checkIfDirty: (state, action) => {
            if (!state.originalValues) {
                state.isDirty = false;
                return;
            }
            
            const currentValues = action.payload;
            const hasChanges = JSON.stringify(currentValues) !== JSON.stringify(state.originalValues);
            state.isDirty = hasChanges;
        },
    },
});

export const { setDirty, resetDirty, setOriginalValues, checkIfDirty } = dirtySlice.actions;
export default dirtySlice.reducer;
